import React, { Component } from 'react';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class CategoriesTable extends Component {
    constructor( props ) {
        super( props );

        var isRowOpen = {};
        var checked = [];
        var hiddenRows = [];
        var initialValues = [];
        if( props.initialValues ) {
            initialValues = props.initialValues;
            checked = initialValues.map( category => category.id );
            for( var i = 0; i < checked.length; i++ ) {
                isRowOpen[ checked[ i ] ] = true;
            }
        }
        if( props.defaultOpen ) {
            for( var j = 0; j < props.defaultOpen.length; j++ ) {
                isRowOpen[ props.defaultOpen[ j ] ] = true;
            }
        }
        if( props.hideOptions ) {
            hiddenRows = props.hideOptions;
        }

        this.state = {
            isRowOpen: isRowOpen,
            checked: checked,
            hiddenRows: hiddenRows,
        };
        this.data = [ ...initialValues ];
    }
    toggleCheck = ( { id, data } ) => {
        var checked = [ ...this.state.checked ];
        if( this.props.singleSelect ) {
            if( checked.includes( id ) ) {
                checked = [];
                this.data = [];
            } else {
                checked = [ id ];
                this.data = [ data ];
            }
        } else {
            if( checked.includes( id ) ) {
                var index = checked.indexOf( id );
                checked.splice( index, 1 );
                this.data.splice( index, 1 );
            } else {
                checked.push( id );
                this.data.push( data );
            }
        }
        this.props.onChange( { checked: checked, data: this.data } );
        this.setState( { checked: checked } );
    }


    render() {
        const { categories } = this.props;

        return (
            <div>
                <ul className={ style.categoriesTable }>
                    { this.arrayTableRows( categories ) }
                </ul>
            </div>
        );
    }

    renderRow = ( category, parents=[], visible=false ) => {
        var collapseMark = (
            <Icon source='fontAwesome' className='dropdown' icon='fas/faMinus'
            style={ { color: '#e0e0e0' } } />
        );
        var isOpen = this.state.isRowOpen[ category.id ];
        if( category.child_categories.length > 0 ) {
            var collapseFunction = () => {
                this.setState( ( altState ) => {
                    altState.isRowOpen[ category.id ] = !altState.isRowOpen[ category.id ];
                    return altState;
                } );
            };
            if( isOpen ) {
                collapseMark = (
                    <Icon source='fontAwesome' className='dropdown' icon='fas/faChevronDown'
                    style={ { color: '#6461ec' } }
                    onClick={ collapseFunction } />
                );
            } else {
                collapseMark = (
                    <Icon source='fontAwesome' className='dropdown' icon='fas/faChevronUp'
                    style={ { color: '#6461ec' } }
                    onClick={ collapseFunction } />
                );
            }
        }
        return (
            <li className={ style.tableRow + ' dl-table-body' } key={ 'category-' + category.id }
            data-visible={ visible }>
                <div className={ style.tableCell }>
                    <div className={ style.complexContent }>
                        <span className={ style.nestMark } style={ { minWidth: parents.length + 'em' } } />
                        <div className={ style.collapseMark }>
                            { collapseMark }
                        </div>
                        <label>
                            <input type='checkbox' checked={ this.state.checked.includes( category.id ) }
                            onChange={ () => { this.toggleCheck( { id: category.id, data: category } ); } } />
                            <div>{ category.name }</div>
                        </label>
                    </div>
                </div>
                <div className={ style.tableCell } >
                    { category.status }
                </div>
            </li>
        );
    }
    convertToRows = ( rowData={}, parents=[], visible=false ) => {
        var rows = [];
        rows.push( this.renderRow( rowData, parents, visible ) );

        var showChildren = visible && this.state.isRowOpen[ rowData.id ];
        for( var i = 0; i < rowData.child_categories.length; i++ ) {
            var category = rowData.child_categories[i];
            if( !this.state.hiddenRows.includes( category.id ) ){
                rows.push( ...this.convertToRows( category, [ ...parents, rowData.id ], showChildren ) );
            }
        }
        return rows;
    }

    arrayTableRows = ( categories ) => {
        var rows = [];
        for( var i = 0; i < categories.length; i++ ) {
            var category = categories[i];
            if( !this.state.hiddenRows.includes( category.id ) ){
                rows.push( ...this.convertToRows( categories[ i ], [], true ) );
            }
        }

        rows.unshift( (
            <li className={ style.tableRow + ' dl-table-head' } key='-1'>
                <div className={ style.tableCell }>
                    CATEGORY NAME
                </div>
                <div className={ style.tableCell } >
                    STATUS
                </div>
            </li>
        ) );

        return rows;
    }
}
CategoriesTable.defaultProps = {
    onChange: () => {},
};

export default CategoriesTable;
